<div class="site-width">
  <div class="container-fluid pt-2 pt-md-4">
    <div class="mb-2 mb-md-3">
      <h3
        class="h4 text-md-center mx-auto mb-0"
        [ngClass]="{'mb-0' : widgets?.information}"
        [attr.data-e2e]="e2e + '-title'"
        >
        {{ widgets.title }}
      </h3>

      @if (widgets.information) {
        @for (item of widgets.information; track item; let index = $index) {
          <p
            class="standard text-mw mx-auto mb-0"
            [attr.data-e2e]="e2e + '-info-' + index"
            [innerHTML]="item"
          ></p>
        }
      }
    </div>

    <div class="row">
      @if (widgets.items.length === 1) {
        <div class="col-12">
          <div
            class="card ob1-push ob1-push-shadow-right"
            [ngClass]="{ 'ob1-push-no-interaction': !widgets.items[0].href }"
            >
            <div class="row align-items-md-center">
              <div class="col-12 col-md-6 mb-2 mr-auto">
                <div class="card-header">
                  <img
                    class="card-img-top"
                    [src]="widgets.items[0].picture"
                    [alt]="widgets.items[0].alt || ''"
                    [attr.data-e2e]="e2e + '-image-0'"
                    />
                </div>
              </div>
              <div class="col-12 col-md-5">
                <div class="card-body">
                  <h4 class="card-title" [attr.data-e2e]="e2e + '-title-0'">{{ widgets.items[0].title }}</h4>
                  <p class="card-text standard" [attr.data-e2e]="e2e + '-text-0'">{{ widgets.items[0].description }}</p>
                  @if (widgets.items[0].buttonLabel) {
                    <p class="py-0 card-btn mt-md-1">
                      <a
                        [href]="widgets.items[0].href || '#'"
                        [attr.data-e2e]="e2e + '-button-0'"
                        class="btn btn-secondary"
                        (click)="emitButtonClickEvent('widget', 0, widgets.items[0].href);false"
                        >
                        {{ widgets.items[0].buttonLabel }}
                      </a>
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      } @else {
        @for (widget of widgets.items; track widget; let widgetIndex = $index; let last = $last) {
          <div
            class="col-12"
          [ngClass]="{
                     'col-md-5 pl-md-1': widgets.items.length === 2 || widgets.items.length === 4,
                     'offset-md-1': (widgets.items.length === 2 || widgets.items.length === 4) && (widgetIndex === 1 || widgetIndex === 3),
                     'col-md-6 col-xl-4': widgets.items.length === 3 || widgets.items.length >= 5,
                     'mt-md-0 mt-lg-0 mt-xl-2': widgets.items.length === 4 && widgetIndex > 1 || widgets.items.length > 4 && widgetIndex > 2,
                     'mb-1': !last
                     }"
            >
            <div class="card ob1-push ob1-push-shadow-right" [ngClass]="{ 'ob1-push-no-interaction': !widget.href }">
              <div class="card-header">
                <img
                  class="card-img-top"
                  [src]="widget.picture"
                  [alt]="widget.alt || ''"
                  [attr.data-e2e]="e2e + '-image-' + widgetIndex"
                  />
              </div>
              <div class="card-body">
                <h4 class="card-title" [attr.data-e2e]="e2e + '-title-' + widgetIndex">{{ widget.title }}</h4>
                <p
                  class="card-text standard"
                  [attr.data-e2e]="e2e + '-text-' + widgetIndex"
                  [innerHTML]="widget.description"
                ></p>
                @if (widget.buttonLabel) {
                  <p class="py-0 card-btn mt-md-1">
                    <a
                      [href]="widget.href || '#'"
                      [attr.data-e2e]="e2e + '-button-' + widgetIndex"
                      class="btn btn-secondary"
                      (click)="emitButtonClickEvent('widget', widgetIndex, widget.href);false"
                      >
                      {{ widget.buttonLabel }}
                    </a>
                  </p>
                }
              </div>
            </div>
          </div>
        }
      }


    </div>
  </div>
</div>
